<template>
  <div>
    <table cellspacing="4" border="4">
      <h2>恭喜，站点创建成功</h2>
      <h3>这是默认index.html，本页面由系统自动生成</h3>
      <br/>
      <div>
        <p>本页面在FTP根目录下的index.html</p>
        <p>您可以修改、删除或覆盖本页面</p>
        <p>FTP相关信息，请到“面板系统后台 > FTP”查看</p>
      </div>
    </table>
  </div>
</template>

<script>
import kkUtil from '../../assets/js/kk-util'

export default {
  name: 'fake-home',
  methods: {},
  components: {},
  beforeCreate () {
    let branchId = kkUtil.getQueryStr('fcid')
    if (branchId) {
      window.location.href = window.location.protocol + '//' + window.location.host + '/#/home' + '?fcid=' + branchId
    }
  }
}
</script>

<style>
</style>
